module.exports = __webpack_public_path__ + "img/AD.9e010228.png";